exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-website-page-index-tsx": () => import("./../../../src/templates/WebsitePage/index.tsx" /* webpackChunkName: "component---src-templates-website-page-index-tsx" */)
}

